import Vue from "vue";
import i18n from "@/plugins/i18n/translations";

export default {
	state: {
		menus: [],
		breadCrumb: []
	},
	mutations: {
		setBreadCrumbOnState(state, { name, meta }) {
			let breadCrumb = [];
			let routeName = name;
			let routeMeta = meta;

			let menu = this.state.menus.find((m) => {
				return m.screens.find((s) => s.routeName == routeName);
			});
			if (menu) {
				breadCrumb.push({ text: i18n.t(menu?.name) });

				let screen = menu?.screens.find((s) => s.routeName == routeName);
				if (screen) {
					breadCrumb.push({ text: i18n.t(screen?.name) });
				}
			} else if (routeMeta) {
				let metaBreadCrumbs = routeMeta.breadCrumbs;
				(metaBreadCrumbs || []).forEach((route) => {
					breadCrumb.push({ text: route });
				});
			}

			state.breadCrumb = breadCrumb;
		},
		setMenusOnState(state, menus) {
			state.menus = mapMenus(menus);
		},
		cleanMenusOnState(state) {
			state.menus = [];
		}
	},
	actions: {
		getMenuConfigurations({ commit }) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("/menu")
					.then((response) => {
						commit("setMenusOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
					});
			});
		}
	},
	getters: {
		menus: ({ menus }) => {
			return menus;
		},
		breadCrumb: ({ breadCrumb }) => {
			return breadCrumb;
		}
	}
};

function mapMenus(menus) {
	let mappedMenus = [];

	menus.forEach((menu) => {
		let mappedMenu = {
			name: menu.name,
			description: menu.description,
			screens: []
		};
		menu.screens.forEach((screen) => {
			let mappedScreen = mapScreen(screen);
			mappedMenu.screens.push(mappedScreen);
		});
		mappedMenus.push(mappedMenu);
	});

	return mappedMenus;
}

function mapScreen(screen) {
	let mappedScreen = {
		description: screen.description,
		name: screen.name,
		routeName: screen.routeName,
		permissions: []
	};

	screen.permissions.forEach((permission) => {
		mappedScreen.permissions.push({ value: permission, text: Vue.prototype.$permissions[permission] });
	});

	return mappedScreen;
}
